// Page permissions (/sayfa-yetkileri) and its dialogs (password, message,
// people lists, usage statistics). Menu titles are translated by path as in
// the sidebar; stored roles are shown as they are.
const pageAccess = {
  page: {
    title: 'Page Permissions',
    subtitle: 'Pick an employee, see the pages they can open and switch any page on or off. Your choices are saved.',
  },
  actions: {
    showPassive: 'Show Inactive',
    hidePassive: 'Hide Inactive',
    showPassiveHint: 'Include inactive employees in the lists',
    hidePassiveHint: 'Hide inactive employees from the lists',
    stats: 'Usage Statistics',
    statsHint: 'Sign-in counts, online time and the most active users',
  },
  tiles: {
    employees: 'Employees',
    employeesShort: 'Employees',
    online: 'Online Now',
    onlineShort: 'Online',
    admins: 'Admins',
    adminsShort: 'Admins',
    restricted: 'Restricted Admins',
    restrictedShort: 'Restricted',
  },
  roles: {
    employee: 'Employee',
  },
  list: {
    label: 'Employee list',
    search: 'Search employees…',
    filterLabel: 'Employee filter',
    all: 'All',
    online: 'Online',
    granted: 'Extra access',
    grantedHint: 'Employees given extra pages on this screen',
    loading: 'Loading…',
    empty: 'No employees found',
    count_one: '{{count}} employee',
    count_other: '{{count}} employees',
    accessTitle: 'Number of pages they can open',
    onlineTitle: 'Online',
    offlineTitle: 'Offline',
    passive: 'Inactive',
  },
  editor: {
    label: 'Page permissions',
    placeholderTitle: 'Pick an employee',
    placeholderText: 'Pick an employee from the list to edit the pages they can open here.',
    back: 'Employees',
    password: 'Change Password',
    passwordHint: 'Change this user’s password',
    summary: 'of {{total}} pages',
    summaryHint: 'Pages they can open (unsaved changes included)',
    legend: {
      role: 'Access by role',
      special: 'Special access (code)',
      granted: 'Added',
      none: 'No access',
    },
    search: 'Search pages…',
    filterLabel: 'Page filter',
    filter: {
      all: 'All',
      on: 'With access',
      off: 'Without access',
    },
    noMatch: 'No page matches the search',
    tag: {
      role: 'Role',
      special: 'Code',
      granted: 'Added',
    },
    locked: 'This access comes from the role or the code and can’t be removed here',
    remove: 'Remove this page',
    add: 'Add this page',
    addAll: 'Add all',
    removeAll: 'Remove all',
    groupHint: 'Every page of this menu that the role or the code doesn’t give',
    unsaved_one: '{{count}} unsaved change',
    unsaved_other: '{{count}} unsaved changes',
    reset: 'Reset',
    save: 'Save',
    saving: 'Saving…',
  },
  switchConfirm: {
    title: 'Unsaved changes',
    message: 'Your changes for {{name}} are not saved. If you continue without saving, they are lost.',
    confirm: 'Continue Without Saving',
    cancel: 'Go Back',
  },
  people: {
    admins: {
      title: 'Employees with Admin Rights',
      empty: 'No employee has the "admin" authorisation.',
    },
    restricted: {
      title: 'Employees with Restricted Admin Rights',
      empty: 'No employee has the "Kısıtlı Admin" authorisation.',
    },
    online: {
      title: 'Online Users',
      empty: 'Nobody is online right now.',
    },
    count_one: '{{count}} person',
    count_other: '{{count}} people',
    loading: 'Loading…',
    editHint: 'Edit this employee’s page permissions',
    message: 'Message',
    messageHint: 'Send this employee a message',
    access: 'Permissions',
    noPage: 'No page information yet',
    close: 'Close',
  },
  activity: {
    login: 'Sign-in screen',
    loginGroup: 'Home',
    other: 'Other',
  },
  message: {
    title: 'Send Message',
    noEmail: 'No e-mail address',
    label: 'Message',
    placeholder: 'Write your message…',
    hint: 'The message lands in the employee’s inbox, where they can reply. Press Ctrl + Enter to send.',
    cancel: 'Cancel',
    send: 'Send',
    sending: 'Sending…',
  },
  password: {
    title: 'Change Password',
    label: 'New password',
    placeholder: 'At least 6 characters',
    generate: 'Generate',
    generateHint: 'Create a strong password',
    sendEmail: 'E-mail the new password to the user',
    cancel: 'Cancel',
    submit: 'Update Password',
    saving: 'Saving…',
    errors: {
      noEmail: 'This employee has no e-mail address, so the password can’t be changed.',
      tooShort: 'The password must be at least 6 characters.',
      noSession: 'No session found. Please sign in again.',
      failed: 'The password could not be updated.',
      generic: 'An error occurred while updating the password.',
    },
  },
  time: {
    justNow: 'just now',
    justNowCap: 'Just now',
    minutes: '{{m}} min',
    hours: '{{h}} h',
    hoursMinutes: '{{h}} h {{m}} min',
    seconds: '{{s}} s',
    never: 'No activity yet',
    minutesAgo: '{{m}} min ago',
    hoursAgo: '{{h}} hours ago',
    daysAgo: '{{d}} days ago',
  },
  stats: {
    title: 'Usage Statistics',
    subtitle: 'Sign-ins and session time of the last 30 days',
    tabsLabel: 'Statistics view',
    overview: 'Overview',
    users: 'User Details',
    loading: 'Loading sign-in records…',
    error: 'The sign-in history could not be fully loaded; the figures may be incomplete.',
    online: 'Online Now',
    onlineShort: 'Online',
    active30: 'Active Users (30 days)',
    active30Short: 'Active (30 days)',
    logins30: 'Sign-ins (30 days)',
    logins30Short: 'Sign-ins (30 d)',
    totalOnline: 'Total Online Time',
    totalOnlineShort: 'Online time',
    chartTitle: 'Daily Sign-ins (Last {{days}} Days)',
    chartBar: '{{date}}: {{count}} sign-ins',
    top: 'Most Active Users (30 days)',
    topEmpty: 'No sign-ins in the last 30 days.',
    topMeta: '{{logins}} sign-ins · {{duration}}',
    least: 'Inactive Users (no sign-in in 30 days)',
    leastEmpty: 'Everyone signed in at least once in the last 30 days.',
    lastActivity: 'Last activity: {{time}}',
    columns: {
      user: 'User',
      status: 'Status',
      lastActivity: 'Last Activity',
      logins30: 'Sign-ins (30d)',
      totalLogins: 'Total Sign-ins',
      totalOnlineMs: 'Total Time',
    },
    statusOnline: 'Online',
    statusOffline: 'Offline',
    logins7: 'Sign-ins (7 days)',
    avgSession: 'Avg. Session',
    activeSession: 'Current Session',
    lastSession: 'Last Session',
    recentTitle: 'Recent Sign-ins ({{count}} in 30 days)',
    recentEmpty: 'No sign-ins in the last 30 days.',
    more: '+ {{count}} more sign-ins',
    sessionRecord: 'Session record',
    unknownDevice: 'Unknown device',
    browser: 'Browser',
    expand: 'Show details',
    collapse: 'Hide details',
    footnote: 'Sign-in counts come from the sign-in history and online time from session tracking. If time tracking was enabled recently, earlier sessions are not in the totals.',
    close: 'Close',
  },
  toast: {
    loadError: 'The employees could not be loaded',
    noSession: 'No session found; the message was not sent.',
    noReceiverEmail: 'This employee has no e-mail address, so a message can’t be sent.',
    messageSent: 'Message sent to {{name}}',
    messageError: 'The message could not be sent',
    saved: 'Page permissions saved for {{name}}',
    saveError: 'The permissions could not be saved',
    passwordMailed: 'Password updated and sent by e-mail.',
    passwordMailFailed: 'Password updated, but the e-mail could not be sent. Please pass it on manually.',
    passwordUpdated: 'Password updated.',
  },
};

export default pageAccess;
